export const SUBSCRIPTION_REQUEST_ENDPOINTS = {
  ACTIVE_PROMOTIONS: "/organizations/:organizationId/active_promotions",
  UPSELL_OFFER: "/organizations/:organizationId/upsell_offer",
  CREATE: "/organizations/:organizationId/subscription_requests",
} as const;
